import React from 'react'
import { Route, Outlet } from 'react-router-dom'

import { Navigate } from 'router'
import ContactList from './List/List'
import Card from './List/Card'
import Edit from './Edit'
import DisableUser from './List/Card/DisableUser'
import CheckEmail from './Actions/CheckEmail'
import ContactsExport from './Actions/ContactsExport'

const ContactsRoutes = () => [
  <Route path="contacts" key="contacts" element={<Outlet />}>
    <Route path={''} element={<Navigate pathname={'list'} />} />
    <Route path={'list'} element={<ContactList />}>
      <Route path={'check-email'} element={<CheckEmail />} />
      <Route path={'export'} element={<ContactsExport />} />
      <Route path={':sfId'} element={<Card />}>
        <Route path={'disable-user'} element={<DisableUser />} />
        <Route path={'check-email'} element={<CheckEmail />} />
      </Route>
    </Route>
    <Route path={'edit/:sfId'} key={'admin-edit'} element={<Edit />} />
  </Route>
]

export default ContactsRoutes
